import { useQuery } from '@tanstack/react-query'

import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'
import { QUERY_KEYS } from '@/lib/queryKeys'

import { getPickupOrderSettings } from '../configService'

export const usePickupOrderSettings = () => {
  const { data: loggedUser } = useCurrentUser()
  const isLoggedIn = !!loggedUser?.id

  return useQuery({
    queryKey: [QUERY_KEYS.PICKUP_ORDER_SETTINGS],
    queryFn: getPickupOrderSettings,
    enabled: isLoggedIn,
    staleTime: 2 * 60 * 1000,
  })
}
